import { render, staticRenderFns } from "./transportationModel.vue?vue&type=template&id=82dc0346&scoped=true"
import script from "./transportationModel.vue?vue&type=script&lang=js"
export * from "./transportationModel.vue?vue&type=script&lang=js"
import style0 from "./transportationModel.vue?vue&type=style&index=0&id=82dc0346&prod&lang=css"
import style1 from "./transportationModel.vue?vue&type=style&index=1&id=82dc0346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dc0346",
  null
  
)

export default component.exports